module.exports = __webpack_public_path__ + "img/desktop/Menus-betmenu/btn-history-up@1x.png?1.0.24";


//////////////////
// WEBPACK FOOTER
// ./out/img/desktop/Menus-betmenu/btn-history-up@1x.png
// module id = 557
// module chunks = 0